var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPopupQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    fill: "#DADFFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.9993 32.916C40.9591 32.916 38.7493 35.1499 38.7493 37.604C38.7493 38.5705 37.9658 39.354 36.9993 39.354C36.0329 39.354 35.2493 38.5705 35.2493 37.604C35.2493 32.9469 39.3076 29.416 43.9993 29.416C48.6911 29.416 52.7493 32.9469 52.7493 37.604C52.7493 40.8376 50.4171 43.3799 47.8218 44.6833C46.4598 45.3673 45.7493 46.3573 45.7493 47.1893V49.8327C45.7493 50.7992 44.9658 51.5827 43.9993 51.5827C43.0329 51.5827 42.2493 50.7992 42.2493 49.8327V47.1893C42.2493 44.4128 44.3885 42.4909 46.2511 41.5555C48.1447 40.6045 49.2493 39.0502 49.2493 37.604C49.2493 35.1499 47.0396 32.916 43.9993 32.916Z",
    fill: "#151F57"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9993 54.4993C44.9658 54.4993 45.7493 55.2829 45.7493 56.2493V57.416C45.7493 58.3825 44.9658 59.166 43.9993 59.166C43.0329 59.166 42.2493 58.3825 42.2493 57.416V56.2493C42.2493 55.2829 43.0329 54.4993 43.9993 54.4993Z",
    fill: "#151F57"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9993 20.666C31.1127 20.666 20.666 31.1127 20.666 43.9993C20.666 56.886 31.1127 67.3327 43.9993 67.3327C56.886 67.3327 67.3327 56.886 67.3327 43.9993C67.3327 31.1127 56.886 20.666 43.9993 20.666ZM24.0806 43.9993C24.0806 32.9986 32.9986 24.0806 43.9993 24.0806C55.0001 24.0806 63.918 32.9986 63.918 43.9993C63.918 55.0001 55.0001 63.918 43.9993 63.918C32.9986 63.918 24.0806 55.0001 24.0806 43.9993Z",
    fill: "#151F57"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopupQuestion);
export default __webpack_public_path__ + "static/media/popup_question.afdd5363f0398829b2157fd44748b643.svg";
export { ForwardRef as ReactComponent };